import * as React from 'react'
import { useInView } from '../../../utils/hooks/hooks/useInView'
import { InviewProps } from './blocksState'

export type IframeBlock = {
  index: number
  url: string
  width: string
  widthUnit: 'percentage' | 'px'
  height: string
  heightUnit: 'percentage' | 'px'
  inview?: InviewProps
}

export function IframeBlockLayout(props: IframeBlock) {
  const { index, url, width, widthUnit, height, heightUnit } = props
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("IframeBlockLayout inView:", inview),
    true
  )
  return (
    <>
      {url && (
        <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={`block block--iframe ${inView ? 'inview' : ''}`}>
          <div className='block__inner container--s gutter--m spacing--m'>
            <div className='block__content'>
              <iframe
                className='block__iframe'
                src={url}
                width={widthUnit == 'percentage' || !width ? `${!!width ? width : 100}%` : width}
                height={heightUnit == 'percentage' || !height ? `${!!height ? height : 100}%` : height}
              ></iframe>
            </div>
          </div>
        </section>
      )}
    </>
  )
}
